import { motion } from "framer-motion";
import { Coins, MessageSquare, Zap } from "lucide-react";

const tiles = [
  {
    icon: Coins,
    title: "AB 80 €",
    subtitle: "Kleine Tattoos",
    description: "Schnell, fair und professionell ausgeführt — perfekt für deinen ersten oder nächsten Wunsch.",
    accent: true,
  },
  {
    icon: MessageSquare,
    title: "KOSTENLOS",
    subtitle: "Erstberatung",
    description: "Inklusive Entwurf bei verbindlicher Terminvereinbarung. Wir nehmen uns Zeit für deine Idee.",
    accent: false,
  },
  {
    icon: Zap,
    title: "SCHNELL",
    subtitle: "Terminvergabe",
    description: "Keine langen Wartezeiten. Direkt einen Termin sichern und zeitnah starten.",
    accent: false,
  },
];

export default function PricingSection() {
  return (
    <section
      id="preise"
      data-testid="pricing-section"
      className="py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <span className="section-label">Transparenz</span>
          <h2 className="section-heading">Klar & fair.</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {tiles.map((tile, i) => (
            <motion.div
              key={i}
              data-testid={`pricing-tile-${i}`}
              className={`group p-8 border transition-all duration-500 hover:shadow-[0_0_30px_rgba(201,168,76,0.15)] ${
                tile.accent
                  ? "bg-[#C9A84C]/5 border-[#C9A84C]/60 hover:border-[#C9A84C]"
                  : "bg-[#141414] border-[#5A4A1A]/40 hover:border-[#C9A84C]/60"
              }`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.6 }}
            >
              <div className="mb-6">
                <tile.icon
                  size={32}
                  className="text-[#C9A84C]"
                  strokeWidth={1.5}
                />
              </div>
              <p className="font-cormorant text-4xl text-[#C9A84C] font-bold mb-1">
                {tile.title}
              </p>
              <p className="text-[#F0F0F0] text-sm tracking-[0.15em] uppercase font-outfit mb-4">
                {tile.subtitle}
              </p>
              <p className="text-[#888888] text-sm font-outfit leading-relaxed">
                {tile.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-12 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <p className="text-[#888888] text-sm font-outfit mb-6">
            Kostenlose Beratung inkl. Entwurf bei verbindlicher Terminvereinbarung.
          </p>
          <a href="#kontakt" data-testid="pricing-cta" className="gold-btn">
            Jetzt Termin anfragen
          </a>
        </motion.div>
      </div>
    </section>
  );
}
